

export class HttpStatusError extends Error {

    constructor(public status: number, public response?: any) {
        super('HTTP_ERROR');
    }
}